import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useExecucaoList } from '../../hooks/useChecklists'
import styles from '../_shared/CrudPage.module.css'

const STATUS_COR: Record<string, string> = {
  em_andamento: '#F57C00',
  concluida: '#388E3C',
}

export default function ExecucoesListPage() {
  const [filtroStatus, setFiltroStatus] = useState<string>('')
  const list = useExecucaoList({
    ...(filtroStatus ? { status: filtroStatus } : {}),
  })

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Execuções de Checklist</h1>
      </header>

      <div className={styles.toolbar}>
        <select
          className={styles.search}
          style={{ maxWidth: 220 }}
          value={filtroStatus}
          onChange={(e) => setFiltroStatus(e.target.value)}
          aria-label="Filtrar por status"
          data-testid="execucoes-filtro-status"
        >
          <option value="">Todas</option>
          <option value="em_andamento">Em andamento</option>
          <option value="concluida">Concluídas</option>
        </select>
      </div>

      {list.isLoading && <p className={styles.loading}>Carregando...</p>}

      {!list.isLoading && (list.data?.results ?? []).length === 0 && (
        <p className={styles.empty}>Nenhuma execução encontrada.</p>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {list.data?.results.map((ex) => (
          <Link
            key={ex.id}
            to={`/checklists/execucoes/${ex.id}`}
            data-testid={`execucao-${ex.id}`}
            style={{
              padding: '1rem',
              background: 'white',
              borderLeft: `4px solid ${STATUS_COR[ex.status] ?? '#888'}`,
              borderRadius: '4px',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
              textDecoration: 'none',
              color: 'inherit',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <strong>{ex.template_nome ?? 'Checklist'}</strong>
              <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#666' }}>
                OS: {ex.ordem_servico.slice(0, 8)}…
                {ex.tecnico_str && ` • Técnico: ${ex.tecnico_str}`}
              </p>
            </div>
            <span
              style={{
                padding: '0.2rem 0.6rem',
                borderRadius: '4px',
                background: `${STATUS_COR[ex.status] ?? '#888'}20`,
                color: STATUS_COR[ex.status] ?? '#888',
                fontSize: '0.85rem',
              }}
            >
              {ex.status === 'em_andamento' ? 'Em andamento' : 'Concluída'}
            </span>
          </Link>
        ))}
      </div>
    </div>
  )
}
